export default function ProgressBar(props) {
  return (
    <div className="flex justify-center -mt-5 ">
      <span className="w-[80%]  md:hidden">
        <span className="flex flex-row justify-between items-center">
          <p>Progress</p>
          <span className="text-primary">
            {props.ans}/{props.que} completed
          </span>
        </span>
        <span className=" max-w-full ">
          <div className="border border-primary  rounded-full h-4 min-w-[90%]">
          <div
            className="bg-primary h-full rounded-full lg:text-xl"
            style={{ width: `${props.score}%` }}
          ></div>
          </div>
        </span>
      </span>
    </div>
  );
}
